import { render, staticRenderFns } from "./ChangePinyin.vue?vue&type=template&id=0da3d27a&scoped=true&"
import script from "./ChangePinyin.vue?vue&type=script&lang=js&"
export * from "./ChangePinyin.vue?vue&type=script&lang=js&"
import style0 from "./ChangePinyin.vue?vue&type=style&index=0&id=0da3d27a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da3d27a",
  null
  
)

export default component.exports